import { ArrowRightIcon, Button, Modal, Separator } from '@farol-ds/react'
import { ReactNode } from 'react'

import { ModalProvider, useMetrics } from '../../hooks'
import styles from './details-modal.module.scss'

export interface DetailsModalProps {
  children: ReactNode
  onShowMoreDetailsModalClick?: () => void
  showModalHeader?: boolean
}

export function DetailsModal(props: DetailsModalProps) {
  const { children, onShowMoreDetailsModalClick, showModalHeader = true } = props
  const { ref: dispatcherRef, sendMetrics } = useMetrics<HTMLDivElement>()

  const onButtonClick = () => {
    sendMetrics('Doc.ShowMoreDetailsClicked')
    onShowMoreDetailsModalClick?.()
  }

  return (
    <div className={styles.modalWrapper} ref={dispatcherRef}>
      <Separator />
      <Modal>
        <Modal.Trigger>
          <Button
            kind="plain"
            rightIcon={<ArrowRightIcon size="sm" />}
            onClick={onButtonClick}
            data-testid="modal-trigger-button"
          >
            Mostrar mais detalhes
          </Button>
        </Modal.Trigger>

        <Modal.Content>
          <Modal.IconClose />
          {showModalHeader && (
            <Modal.Header>
              <Modal.HeaderTitle>Mais Detalhes</Modal.HeaderTitle>
            </Modal.Header>
          )}

          <Modal.Body>
            <ModalProvider>{children}</ModalProvider>
          </Modal.Body>
        </Modal.Content>
      </Modal>
      <Separator />
    </div>
  )
}
